import { NgModule } from '@angular/core';
import { CommonModule} from '@angular/common';
import {SynchroPaginatePipe} from './synchro-paginate.pipe';
@NgModule({
  imports:[
    CommonModule
  ],
  declarations: [SynchroPaginatePipe],
  providers: [ ],
  exports: [SynchroPaginatePipe]
})
export class SynchroPaginatePipeModule {

}
